import { render, staticRenderFns } from "./twoauthen.vue?vue&type=template&id=35f3112c&scoped=true&lang=html"
import script from "./twoauthen.vue?vue&type=script&lang=js"
export * from "./twoauthen.vue?vue&type=script&lang=js"
import style0 from "./twoauthen.vue?vue&type=style&index=0&id=35f3112c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f3112c",
  null
  
)

export default component.exports